module.exports = __webpack_public_path__ + "static/media/BeVietnam-Bold.c8f387f6.ttf";